<style scoped>
  .tab >>> .ivu-tabs-nav{line-height: 60px;margin-left:30px;}
  .tab >>>.ivu-tabs-tab{line-height: 60px;}
  .tab >>> .ivu-tabs-bar{margin-bottom: 0;}
  .notice-background{background: url("/img/sys/bg2.png");height: 140px;}
  .search >>> .ivu-input {width: 348px;height: 36px;border-radius: 18px;font-size: 14px;color: #bbbbbb;padding: 0 30px 0 22px;}
  .notice-background{background: url("/img/sys/bg11.png");height: 140px;}
  .gradualChange{background:url('/img/systemSetup/gradualChange.png');background-repeat:no-repeat;width: 318px;height: 95px;display: inline-block;text-align: left;}
  .plateTrue{width: 238px;height: 108px;background-color: #fff;box-shadow: 0px 0px 12px rgba(0,0,0,0.1);border-radius: 6px;display: flex;align-items: center;margin-top: 40px;}
  .plateFalse{width: 238px;height: 108px;background-color: #f7f8ff;border-radius: 6px;display: flex;align-items: center;margin-top: 40px;}
  .eventName{font-size: 16px;display: inline-block;vertical-align: top;margin-left: 19px;}
  .eventFrame{width: 4px;height: 20px;background-color: #00a2e9;display: inline-block;border-radius: 2px;}
  .newlyBuild{width: 100px;height: 36px;line-height: 36px;color: #fff;font-size: 14px;box-shadow: 0px 0px 12px rgba(255,153,0,0.5);background-color: #ff9900;border-radius: 18px;float: right;}
  .list{width: 722px;height: 108px;background-color: #f7f8ff;display: flex;align-items: center;border-radius: 6px;}
  .enable{margin-left:15px;color: #55c1f0;font-size: 14px;padding: 0 10px;border-radius: 11px;border: 1px solid #55c1f0;display: inline-block;line-height: 22px;}
  .button{margin-right:24px;background-color: #fff;font-size: 14px;color: #00a2e9;width: 80px;height: 30px;text-align: center;line-height: 30px;box-shadow: 0px 0px 12px rgba(45,140,240,0.1);border-radius: 15px;display: inline-block;}
</style>
<template>
  <div>
    <Modal
        v-model="typePanel.state"
        title="发起审批"
        width="1100"
    >
      <Row style="background-color: #fff;padding-bottom:40px">
        <i-col span="8" style="text-align: center;border-right: 1px solid #d7dde4">
          <div class="gradualChange">
            <img style="margin: 26px 10px 0 21px;vertical-align: top;" src="/img/project/fault-icon.png">
            <p style="color: #fff;font-size: 16px;display: inline-block;margin-top:24px;">审批类型</p>
          </div>
          <div style="background-color: #fff;width: 318px;display: inline-block;box-shadow: 0px 0px 12px rgba(0,0,0,0.1);text-align: center;margin-top: -24px;font-size: 0">
            <div style="display: inline-block;min-height:444px;">
              <div class="plateTrue" v-for="(item,index) in typeList.list">
                <div style="display: inline-block;cursor: pointer;text-align: left;"@click="modelList.search.key = item.id">
                  <div class="eventFrame" style="vertical-align: middle"></div>
                  <p class="eventName" style="color: #00a2e9;vertical-align: middle;line-height: 37px;">{{item.name}}</p>
                  <div style="color: #a8a8b2;font-size: 14px;margin-left: 19px;line-height: 37px">
                    <p style="display: inline-block;">创建时间：{{item.createTime}} </p>
                  </div>
                </div>
              </div>
            </div>
            <!--分页-->
            <div style="margin: 40px 0px 40px 40px;text-align: left;font-size: 12px">
              <Page
                  :page-size="typeList.search.pageSize"
                  :total="typeList.search.total"
                  @on-change="typeList.search.page = $event;getTypeList()"
              />
            </div>
          </div>
        </i-col>
        <i-col span="16" style="padding-left:15px;">
          <div style="height: 71px;border-bottom: 1px solid #d7dde4;display: flex;align-items: center;margin: 0 40px;">
            <div style="display: inline-block;">
              <img style="vertical-align: top;margin-right: 11px;" src="/img/project/template-icon.png"/>
              <p style="color: #434343;font-size: 16px;display: inline-block;">{{modelList.title}}</p>
            </div>
          </div>
          <!--列表-->
          <div style="min-height:445px;">
            <div style="display: flex;justify-content: center;margin-top: 40px;cursor: pointer" v-for="(item,index) in modelList.list" @click="getModel(item)">
              <div class="list">
                <div style="display: inline-block;margin-left: 24px;line-height: 37px;">
                  <div>
                    <p style="font-size: 16px;color: #464c5b;display: inline-block;">{{item.name}}</p>
                    <div class="enable">已启用</div>
                  </div>
                  <!-- <div style="color: #a8a8b2;font-size: 14px;">
                    <p style="display: inline-block">创建人：{{item.creater}} </p>
                    <p style="display: inline-block">&nbsp;&nbsp; 时间：{{item.createTime}} </p>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <!--分页-->
          <div style="margin: 40px 0px 40px 40px;text-align: left;">
            <Page
                :page-size="modelList.search.pageSize"
                :total="modelList.search.total"
                @on-change="modelList.search.page = $event;getModelList()"
            />
          </div>
        </i-col>
      </Row>
    </Modal>
    <Modal
        @on-ok="createApproval()"
        v-model="modelPanel.state"
        :title="modelPanel.name"
    >
      <template v-for="(item,index) in approvalData">
        <component
            :key="'approvalCenter'+modelPanel.id+index"
            v-if="item.display!='none'||item.content.filesSrc!=''"
            :contentIn="item.content"
            pattern="submission"
			      style="margin: 10px auto;"
            :index="index"
            :is="item.name"
            @change="item.content=$event"
            @del="approval.splice($event,1)"
        ></component>
      </template>
      <div slot="footer">
        <Button type="text" size="large" @click="modelPanel.state = false">取消</Button>
        <Button type="primary" size="large" @click="createApproval">发起审批</Button>
      </div>
    </Modal>
    <Modal v-model="exportPanel.state" ok-text="导出" title="批量导出" @on-ok="exportPDF">
      <Row type="flex" align="middle">
        <Col span="5" style="text-align: right">选择起始时间：</Col>
        <Col span="14"><DatePicker type="date" placeholder="请选择起始日期" @on-change="exportPanel.startTime = $event" style="width: 200px"></DatePicker></Col>
      </Row>
      <div style="padding:5px"></div>
      <Row type="flex" align="middle">
        <Col span="5" style="text-align: right">选择结束时间：</Col>
        <Col span="14"><DatePicker type="date" placeholder="请选择截止日期" @on-change="exportPanel.endTime = $event" style="width: 200px"></DatePicker></Col>
      </Row>
      <div style="padding:5px"></div>
      <Row type="flex" align="middle">
        <Col span="5" style="text-align: right">选择导出类型：</Col>
        <Col span="14">
          <Select v-model="exportPanel.type" style="width:200px">
            <Option value="3">我发起的</Option>
            <Option value="1">抄送我的</Option>
            <Option value="2">我审批的</Option>
          </Select>
        </Col>
      </Row>
      <div style="padding:5px"></div>
      <Row type="flex" align="middle">
        <Col span="5" style="text-align: right">选择审批状态：</Col>
        <Col span="14">
          <Select v-model="exportPanel.finish" style="width:200px">
            <Option value="3">全部</Option>
            <Option value="2">进行中</Option>
            <Option value="1">已完成</Option>
          </Select>
        </Col>
      </Row>
    </Modal>
    <Row>
      <Col span="24" class="notice-background"></Col>
    </Row>
    <Row style="background-color: white;border-bottom: 1px solid #d7dde4;height: 114px;">
      <Col span="20" style="position: absolute;top: 50%;left:20px;transform: translate(0, -50%);">
        <div style="position: relative;">
          <Input class="search" v-model="search.text" placeholder="搜索项目名称/客户名称/主体名称"></Input>
          <div @click="$refs.list.$refs.list.getApprovalList(search.text)" style="background-color: #00a2e9;width: 28px;height: 28px;border-radius: 14px;position: absolute;top: 4px;text-align: center;left: 310px;cursor:pointer;">
            <img style="margin-top: 6px;" src="/img/project/search-icon.png"/>
          </div>
        </div>
      </Col>
      <Col span="5" class="approval" style="text-align:right;position: absolute;top: 50%;right:40px;transform: translate(0, -50%);">
        <Button size="large" type="success" shape="circle" @click="exportPanel.state=true">批量导出</Button>
        <span style="padding:5px"></span>
        <Button size="large" type="warning" shape="circle" @click="getTypeList()">发起审批</Button>
      </Col>
    </Row>
    <Menu mode="horizontal" theme="light" active-name="1" style="padding:0 30px;">
      <MenuItem name="1" :to="{name:'approvalSubmission'}">
        <Icon type="ios-construct"/>
        我发起的
      </MenuItem>
      <MenuItem name="2" :to="{name:'approvalForwarding'}">
        <Icon type="ios-paper"/>
        抄送我的
      </MenuItem>
      <MenuItem name="3" :to="{name:'approvalHandle'}">
        <Icon type="ios-people"/>
        我审批的
      </MenuItem>
    </Menu>
    <Row class="tab" style="max-width: 1200px;background-color:#FFF">
      <Col span="24" >
        <router-view ref="list"></router-view>
      </Col>
    </Row>
  </div>
</template>

<script>
  import approvalCheckbox from '../../components/setting/approval/approvalCheckbox'
  import approvalDate from '../../components/setting/approval/approvalDate'
  import approvalDateRange from '../../components/setting/approval/approvalDateRange'
  import approvalFile from '../../components/setting/approval/approvalFile'
  import approvalFiles from '../../components/setting/approval/approvalFiles'
  import approvalInput from '../../components/setting/approval/approvalInput'
  import approvalRadio from '../../components/setting/approval/approvalRadio'
  import approvalTextarea from '../../components/setting/approval/approvalTextarea'
  import approvalTime from '../../components/setting/approval/approvalTime'
  import approvalTimeRange from '../../components/setting/approval/approvalTimeRange'
  import approvalExplain from '../../components/setting/approval/approvalExplain'
  export default {
    name: "approval",
    data (){
      return {
        exportPanel:{
          state:false,
          startTime:'',
          endTime:'',
          type:'',
          finish:'',
        },
        typePanel:{
          state:false,
          search:{
            pageSize: 5,//每页显示多少条
            total: 0,//总条数
            page: 1,//当前页
            text:'',//搜索文字
          },
        },
        modelListPanel:{
          state:false,
          search:{
            pageSize: 5,//每页显示多少条
            total: 0,//总条数
            page: 1,//当前页
            text:'',//搜索文字
          },
        },
        modelPanel:{
          state:false,
          title:'',
          id:'',
        },
        typeList:{
          editType:{
            panel:false,
            name:'',
            id:'',
          },
          search:{
            pageSize: 3,//每页显示多少条
            total: 0,//总条数
            page: 1,//当前页
            text:'',//搜索文字
          },
          list:[],
          switch1:false,
        },
        modelList:{
          title:'',
          list:[],
          switch1:false,
          search:{
            key:'',
            pageSize: 5,//每页显示多少条
            total: 0,//总条数
            page: 1,//当前页
            text:'',//搜索文字
          },
        },
        search:{
          text:'',
        },
        approvalData:[],
      }
    },
    components:{
      approvalCheckbox:approvalCheckbox,
      approvalDate:approvalDate,
      approvalDateRange:approvalDateRange,
      approvalFile:approvalFile,
      approvalFiles:approvalFiles,
      approvalInput:approvalInput,
      approvalRadio:approvalRadio,
      approvalTextarea: approvalTextarea,
      approvalTime: approvalTime,
      approvalTimeRange: approvalTimeRange,
      approvalExplain: approvalExplain,
    },
    watch:{
      'modelList.search.key':function () {
        this.modelList.search.page = 1
        this.getModelList()
      }
    },
    methods : {
      exportPDF:function(){
        var _this = this
        _this.send({
          headers:'L/SearchApprovalList',
          data:{
            StartTime:_this.exportPanel.startTime,
            EndTime:_this.exportPanel.endTime,
            page:1,
            temp:_this.exportPanel.type,
            key:'',
            pageSize:99999999,
            finish:_this.exportPanel.finish,
          },
          success:function (res) {
            console.log(_this.getServerURL('default',false))
            window.location.href = _this.getServerURL('default',false)+res
          }
        })

      },
      getTypeList:function () {
        var _this = this
        _this.typeList.list = []
        _this.send({
          headers:'C/ShowApprovalType',
          data:{
            page : _this.typeList.search.page,
            pageSize : _this.typeList.search.pageSize,
            key : _this.typeList.search.text,
            ApprovalDefault:0,
          },
          success:function (res) {
            var i = 0
            for(var index in res.List){
              _this.$set(_this.typeList.list,i,{})
              _this.$set(_this.typeList.list[i],'id',res.List[index].ApprovalTypeId)
              _this.$set(_this.typeList.list[i],'name',res.List[index].ApprovalTypeTitle)
              _this.$set(_this.typeList.list[i],'createTime',res.List[index].ApprovalTypeCreatedTime)
              i++
            }
            _this.typeList.search.total=res.Count
            if(_this.modelList.search.key==''){
              _this.modelList.search.key = _this.typeList.list[0].id
              _this.modelList.title = _this.typeList.list[0].name
            }
            _this.typePanel.state = true
          }
        })
      },
      getModelList:function () {
        var _this = this
        _this.modelList.list = []
        _this.send({
          headers:'L/ShowApprovalMode',
          data:{
            ApprovalTypeId:_this.modelList.search.key,
            page : _this.modelList.search.page,
            pageSize : _this.modelList.search.pageSize,
            key : _this.modelList.search.text,
          },
          success:function (res) {
            var i = 0
            for(var index in res.List){
              _this.$set(_this.modelList.list,i,{})
              _this.$set(_this.modelList.list[i],'id',res.List[index].ApprovalModeId)
              _this.$set(_this.modelList.list[i],'name',res.List[index].ApprovalModeTitle)
              _this.$set(_this.modelList.list[i],'data',res.List[index].ApprovalModeContent)
              _this.$set(_this.modelList.list[i],'creater',res.List[index].UserName)
              _this.$set(_this.modelList.list[i],'typeName',res.List[index].ApprovalTypeTitle)
              _this.$set(_this.modelList.list[i],'createTime',res.List[index].ApprovalModeCreatedTime)
              _this.$set(_this.modelList.list[i],'editTime',res.List[index].ApprovalModeUpdateTime)
              if(Boolean(res.List[index].ApprovalAssessorId)){
                _this.$set(_this.modelList.list[i],'approverList',res.List[index].ApprovalAssessorId.split(','))
              }else{
                _this.$set(_this.modelList.list[i],'approverList','')
              }
              if(Boolean(res.List[index].ApprovalCopyId)){
                _this.$set(_this.modelList.list[i],'copyList',res.List[index].ApprovalCopyId.split(','))
              }else{
                _this.$set(_this.modelList.list[i],'copyList','')
              }
              i++
            }
            _this.modelList.search.total=res.Count
          }
        })
      },
      createApproval:function(){
        var _this = this
        for(var i = 0;i < _this.approvalData.length;i++){
          if(_this.approvalData[i].content.allowSubmission==false){
            return _this.$Modal.error({
              title:'系统提示',
              content:'请完成所有必填项再进行提交！',
            })
          }
        }
        _this.send({
          headers:'L/AddApproval',
          data:{
            ApprovalModeId:_this.modelPanel.id,
            CaseId:'',
            ApprovalContent:_this.approvalData,
          },
          success:function () {
            _this.$Notice.success({
              title:'系统消息',
              desc:'发起审批成功！'
            })
            _this.modelPanel.state = false
          }
        })
      },
      getModel:function (item) {
        this.approvalData = []
        this.approvalData = item.data
        this.modelPanel.name = item.name
        this.modelPanel.id = item.id
        this.modelPanel.state = true
        this.modelListPanel.state = false
      }
    },
    mounted:function () {
    }
  }
</script>
